import React, { memo } from 'react';
import { IconRatingStar } from 'gatorcomponents';
import * as Styles from './FavoriteButton.styles';

const FavoriteButton = memo(({
  isFavorite,
  onToggle,
  onMouseEnter,
  onMouseLeave,
  isHovered,
}) => {
  const handleClick = () => {
    onToggle();
  };

  return (
    <Styles.Favorite
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={handleClick}
    >
      <IconRatingStar
        size="sm2"
        color={(isFavorite || isHovered) ? 'attentionMedium' : 'lowMedium'}
        filled={isFavorite}
      />
    </Styles.Favorite>
  );
});

FavoriteButton.displayName = 'FavoriteButton';

export default FavoriteButton;
